import { useEffect } from "react";
import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 44 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

export const Reveal = ({ children, className, delay = 0, y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className }) => (
  <span className={`block overflow-hidden ${className || ""}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ eyebrow, title, description, center = true, light = false, testid }) => (
  <Reveal className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-14 lg:mb-20`}>
    {eyebrow && (
      <p className="text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase text-gold mb-4 font-display">
        {eyebrow}
      </p>
    )}
    <h2
      data-testid={testid}
      className={`font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08] ${
        light ? "text-slate-900" : "text-white"
      }`}
    >
      {title}
    </h2>
    {description && (
      <p className={`mt-5 text-base sm:text-lg leading-relaxed ${light ? "text-slate-600" : "text-slate-400"}`}>
        {description}
      </p>
    )}
  </Reveal>
);

export const usePageMeta = (title, description) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | The Trip World` : "The Trip World | Immigration & Visa Consultancy";
    document.title = fullTitle;
    const setMeta = (attr, key, content) => {
      let tag = document.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);
  }, [title, description]);
};

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
